define('view/people/external.associations.page.view',['require','exports','module','uikit/uikit','backbone.radio','blockit','./external.associations.detail.view','./people.left.nav','helpers/make.displayname','fukit/fukit','fukit/fukit','fukit/fukit','fukit/fukit','fukit/fukit','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var UIKit                         = require('uikit/uikit'),
      Radio                         = require('backbone.radio'),
      BlocKit                       = require('blockit'),
      ExternalAssociationsDetailView = require('./external.associations.detail.view'),
      PeopleLeftNav                 = require('./people.left.nav'),
      makeDisplayname               = require('helpers/make.displayname');

  //behaviors
  //prettier-ignore
  var NavigateOnCreateEventBehavior         = require('fukit/fukit').NavigateOnEventBehavior,
      EnableOnlyOnUnsavedChangesBehavior    = require('fukit/fukit').EnableOnlyOnUnsavedChanges,
      SetModelAttributesOnEventBehavior     = require('fukit/fukit').SetModelAttributesOnEventBehavior,
      ConfirmModelDestroyOnPressBehavior    = require('fukit/fukit').ConfirmModelDestroyOnPressBehavior,
      ChangeVisibilityOnModelCreateBehavior = require('fukit/fukit').ChangeVisibilityOnModelCreateBehavior,
      AuthorizationBehavior                 = require('fukit/fukit').AuthorizationBehavior;

  var ExternalAssociationsDetailPageView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      root: {
        type: BlocKit.TwoColumnLeftRailLayoutView,
        pageHeader: {
          headerText: 'My Profile',
          breadcrumbs: [
            {
              text: 'My Profile',
            },
            {
              text: '',
              route: 'profile:detail',
              behaviors: {
                updateCrumbWithPersonNameBehavior: {
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                  optionValues: {
                    text: {
                      model: '@resources.person',
                      formatter: function(model) {
                        return makeDisplayname(
                          model,
                          Radio.request('AppKit.resourceService', 'resource', 'userPrincipalModel')
                        );
                      },
                    },
                  },
                },
              },
            },
            {
              text: 'External Assocations',
            },
          ],
        },
        contentColumn: {
          components: [
            {
              type: ExternalAssociationsDetailView,
              model: '@resources.externalAssociations',
              organizationsCollection: '@resources.organizations',
            },
          ],
        },
        railColumn: {
          components: [
            {
              type: PeopleLeftNav,
              model: '@resources.person',
            },
          ],
        },
      },
    },
  });

  module.exports = ExternalAssociationsDetailPageView;
});

